<template>
  <el-dialog
    :model-value="modelValue"
    title="收集号码"
    width="380px"
    append-to-body
    @update:model-value="emit('update:modelValue', $event)"
  >
    <el-radio-group v-model="selected" class="flex flex-col gap-4 w-full">
      <el-radio :value="1" class="w-full">
        <span class="text-slate-700">发送时替换为该组件默认文案</span>
      </el-radio>
      <el-radio :value="2" class="w-full">
        <span class="text-slate-700">使用抖音默认文案</span>
      </el-radio>
    </el-radio-group>
    <template #footer>
      <el-button @click="emit('update:modelValue', false)">取消</el-button>
      <el-button type="primary" @click="onConfirm">确认</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const TEXT_COLLECT =
  '<p class="mb-2">此处文案由抖音平台提供</p><a href="javascript:;">一键发送抖音绑定手机号</a>';

const props = defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', val: boolean): void;
  (e: 'confirm', content: string): void;
}>();

const selected = ref(1);

watch(
  () => props.modelValue,
  (val) => {
    if (val) selected.value = 1;
  },
);

function onConfirm() {
  emit('confirm', selected.value === 1 ? TEXT_COLLECT : '');
  emit('update:modelValue', false);
}
</script>
